import React from 'react';

import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Responsive } from '@share/utils';
import { WeeksReviewBookWrapper } from '@components';

import './style.scss';

interface IProps extends RouteComponentProps {
  isStripe?: boolean;
}

class WeeksReviewBookPageComponent extends React.Component<IProps> {
  render(): React.ReactNode {
    return (
      <div className="weeks--details-page">
        <Responsive>
          <WeeksReviewBookWrapper isStripe={!!this.props.isStripe} />
        </Responsive>
      </div>
    );
  }
}

export const WeeksReviewBookPage = connect()(withRouter(WeeksReviewBookPageComponent));
